export const FETCH_MEMBERSHIP_REQUESTS_REQUEST = "FETCH_MEMBERSHIP_REQUESTS_REQUEST";
export const FETCH_MEMBERSHIP_REQUESTS_SUCCESS = "FETCH_MEMBERSHIP_REQUESTS_SUCCESS";
export const FETCH_MEMBERSHIP_REQUESTS_FAILURE = "FETCH_MEMBERSHIP_REQUESTS_FAILURE";

export const FETCH_MEMBERSHIP_REQUEST_DETAILS_REQUEST = "FETCH_MEMBERSHIP_REQUEST_DETAILS_REQUEST";
export const FETCH_MEMBERSHIP_REQUEST_DETAILS_SUCCESS = "FETCH_MEMBERSHIP_REQUEST_DETAILS_SUCCESS";
export const FETCH_MEMBERSHIP_REQUEST_DETAILS_FAILURE = "FETCH_MEMBERSHIP_REQUEST_DETAILS_FAILURE";

export const DELETE_MEMBERSHIP_REQUEST_REQUEST = "DELETE_MEMBERSHIP_REQUEST_REQUEST";
export const DELETE_MEMBERSHIP_REQUEST_SUCCESS = "DELETE_MEMBERSHIP_REQUEST_SUCCESS";
export const DELETE_MEMBERSHIP_REQUEST_FAILURE = "DELETE_MEMBERSHIP_REQUEST_FAILURE";
export const CLEAR_MEMBERSHIP_REQUESTS_ERROR = "CLEAR_MEMBERSHIP_REQUESTS_ERROR";

export const FETCH_MEMBERSHIP_PENDING_APPROVALS_REQUEST = "FETCH_MEMBERSHIP_PENDING_APPROVALS_REQUEST";
export const FETCH_MEMBERSHIP_PENDING_APPROVALS_SUCCESS = "FETCH_MEMBERSHIP_PENDING_APPROVALS_SUCCESS";
export const FETCH_MEMBERSHIP_PENDING_APPROVALS_FAILURE = "FETCH_MEMBERSHIP_PENDING_APPROVALS_FAILURE";



